const ITEMS = [
  "1% flat fee",
  "Non-custodial",
  "Instant settlement",
  "Zero volatility",
  "Built on Solana",
  "No middlemen",
];

export default function Marquee() {
  return (
    <section
      className="marquee overflow-hidden border-y border-line bg-panel py-5"
      data-testid="hero-marquee"
      aria-label="B&W Pay highlights"
    >
      <div className="marquee-track flex w-max items-center gap-10 pr-10">
        {[...ITEMS, ...ITEMS].map((t, i) => (
          <span key={i} className="flex items-center gap-10 whitespace-nowrap">
            <span className="text-sm uppercase tracking-[0.35em] text-mut">{t}</span>
            <span className="h-1.5 w-1.5 rotate-45 bg-sgreen" />
          </span>
        ))}
      </div>
    </section>
  );
}
